<div class="custom-percent-component" [ngClass]="getLevelClass()">
  <div class="form-group app-form-margin">
    <div>
      <basic-label [noIndent]="true"></basic-label>
    </div>
    <div>
      <custom-percent-input
        [propertyName]="questionItem.prop"
        [placeholder]="questionItem.placeholder"
        [parserType]="derivedParser"
        [formatterType]="derivedFormatter"
        [extraClasses]="['small']"
      ></custom-percent-input>
    </div>
  </div>
</div>
